import React, {useEffect, useState} from 'react';
import {useMediaQuery} from "@react-hook/media-query";
import {useDispatch, useSelector} from "react-redux";
import Header from './Header';
import {assetsBaseUrl, getNhg} from "../services/calculationsApi";
import Steps from "./Steps";
import {getCalculatorType, stepStates, CALCULATOR_TYPES, removeDotsComas} from "../services/helpers";
import Summary from "./Summary";
import {
    affordCalcAction,
    getMortgageProviderAction,
    mortgageCalcAction,
    parseSearchQuery,
    setField
} from "../store/actions/calculatorActions";
import {defaultStepsState, mainMediaMobile} from "../services/helpers";
import {saveStateToSession} from "../services/stateHelper";
import { RESET_STEPS } from "../store/actionTypes/calculatorActionTypes";
import {FormattedMessage} from "react-intl";
import Usp from "./Usp";

function App() {
    const [stepsState, setStepsState] = useState(defaultStepsState);
    const [loading, setLoading] = useState(false);
    const {Woning, error, summaryWithBanksOpened } = useSelector((state) => state.calculator);
    const state = useSelector((state) => state.calculator);
    const dispatch = useDispatch();
    const mediaMatches = useMediaQuery(mainMediaMobile);

    useEffect(() => {
        const params = parseSearchQuery(window.location.search)

        if (typeof params?.productid !== 'undefined') {
           dispatch(getMortgageProviderAction(params.productid, (params?.isnewbuilding) ? params?.isnewbuilding : false , { value: params.energylabel }))
        }
    }, [dispatch]);

    useEffect(() => {
      saveStateToSession(removeDotsComas(state), getCalculatorType());
    }, [state]);

    useEffect(() => {
      const fetchData = async () => {
        const nhg = await getNhg();
        dispatch(setField('Nhg', nhg));
      };

      fetchData();
    }, [dispatch]);

    const onStepSubmit = async (data, stepNumber) => {
        setLoading(true);
        for (let field in data) {
          //console.log('field',field, data[field])
            dispatch(setField(field, data[field]));
        }

      const houseValue = (typeof data.Woning !== "undefined") ? data?.Woning : Woning;

        if (houseValue > 0) {
            if (getCalculatorType() === CALCULATOR_TYPES.kanIkDitHuisBetalen) {
                if (stepNumber >= 1 || stepsState[1] === 'filled') {
                    //dispatch(mortgageCalcAction());
                    await dispatch(affordCalcAction(stepNumber, false, true));
                } else {
                  await dispatch(mortgageCalcAction());
                }
            }

            if(getCalculatorType() === CALCULATOR_TYPES.watWordenMijnMaandLasten) {
                // fix for not having the default interest
                if(stepsState[1] === 'inactive' && stepNumber === 0) {
                    //await dispatch(mortgageCalcAction());
                }

                await dispatch(affordCalcAction(stepNumber, false, true));
            }

            if (getCalculatorType() === CALCULATOR_TYPES.hoeveelKanIkLenen) {
                await dispatch(affordCalcAction(stepNumber, false, true));
            }

        } else {
            await dispatch(mortgageCalcAction());
        }

        if (mediaMatches) {
            dispatch(setField('lastActiveStepIndex', stepNumber));
        }

        saveStateToSession(removeDotsComas(state), getCalculatorType());
        setLoading(false);
        openStep(stepNumber, true);
    };

    const changeStepState = (stepIndex, newState, nextStepUpdate, prevStepUpdate) => {


        const newStepsState = [...stepsState];
        newStepsState[stepIndex] = newState;

        if (nextStepUpdate) {
            newStepsState[stepIndex + 1] = stepStates.active;
        }

        if (prevStepUpdate) {
            newStepsState[stepIndex - 1] = stepStates.active;
        }

        setStepsState(newStepsState);
        dispatch(setField('stepState', newStepsState));
    };

    const openStep = (stepNumber, nextStepUpdate, prevStepUpdate, isLastStepFilled) => {
        const currentStepState = stepsState[stepNumber];
        let newState;

        //const isLastStepFilled = (stepNumber === 4) && summaryWithBanksOpened && currentStepState === stepStates.active;

        if (nextStepUpdate || currentStepState === stepStates.active || isLastStepFilled) {
            newState = stepStates.filled;
        } else if (currentStepState === stepStates.active) {
            newState = stepStates.closed;
        } else {
            newState = stepStates.active;
        }

        changeStepState(stepNumber, newState, nextStepUpdate, prevStepUpdate);
    };

    const clearState = () => {
        window.localStorage.removeItem(`state.${getCalculatorType()}`);
        setStepsState(defaultStepsState);
        dispatch({
            type: RESET_STEPS,
            stepState: [],
        });
    };

    return (
        <div className="ct-container">
            <Header />

            <a href={document.referrer} className="ct_back-button">
                <img
                    src={`${assetsBaseUrl}/assets/svg/arrow-down-secondary.svg`}
                    alt=""
                />
               <FormattedMessage id="header.back" defaultMessage="Terug" />
            </a>

            <div className="ct-content">
                <Steps
                    openStep={openStep}
                    stepsState={stepsState}
                    error={error}
                    loading={loading}
                    onStepSubmit={onStepSubmit}
                    dispatch={dispatch}
                    onStateClear={clearState}
                />
              {summaryWithBanksOpened && (
                <Summary
                    dispatch={dispatch}
                    changeStepState={changeStepState}
                />
              )}
              {!summaryWithBanksOpened && (
                <Usp>

                </Usp>
              )}
            </div>
        </div>
    );
}

export default App;
